import { CurrencyEnum } from '../../types/enums/common/currency.enum'
import { OLTypeEnum } from '../../types/enums/ol/ol-type.enum'
import { LecBankAccountFilters } from '../../types/models/lec-bank-account/lec-bank-account'

export const transformLecBankAccountFiltersToUrl = (filters?: LecBankAccountFilters): string => {
  if (!filters) return ''
  const searchParams = new URLSearchParams()

  if (filters.currencies && filters.currencies.length)
    searchParams.append('currencies', filters.currencies.join(','))

  if (filters.olTypes && filters.olTypes.length)
    searchParams.append('olTypes', filters.olTypes.join(','))

  return searchParams.toString()
}

export const transformUrlToLecBankAccountFilters = (
  searchParams: URLSearchParams
): LecBankAccountFilters => {
  const filters: LecBankAccountFilters = {}

  const currencies = searchParams.get('currencies')
  if (currencies) filters.currencies = currencies.split(',') as CurrencyEnum[]

  const olTypes = searchParams.get('olTypes')
  if (olTypes) filters.olTypes = olTypes.split(',') as OLTypeEnum[]

  return filters
}
